module.exports = __webpack_public_path__ + "img/help31.570bc326.png";